import { Language } from "@app/provider";

export const isValidLanguageValue = (x: string) => {
  const langValues = Object.values(Language) as string[];
  return langValues.includes(x);
};
